var map = {
	"./AdminBuilder": 44,
	"./AdminBuilder.js": 44,
	"./PageRender": 49,
	"./PageRender.js": 49,
	"./ParallaxImage": 3,
	"./ParallaxImage.js": 3,
	"./SiteFooter": 37,
	"./SiteFooter.js": 37,
	"./SiteHeader": 8,
	"./SiteHeader.js": 8,
	"./admin/ImagePicker": 50,
	"./admin/ImagePicker.js": 50,
	"./admin/MenuEditor": 51,
	"./admin/MenuEditor.js": 51,
	"./frontend/ContactForm": 38,
	"./frontend/ContactForm.js": 38,
	"./frontend/Gallery": 52,
	"./frontend/Gallery.js": 52,
	"./frontend/Modal": 39,
	"./frontend/Modal.js": 39,
	"./widgets": 5,
	"./widgets/": 5,
	"./widgets/ArticleTitleWidget": 26,
	"./widgets/ArticleTitleWidget.js": 26,
	"./widgets/AxSectionWidget": 34,
	"./widgets/AxSectionWidget.js": 34,
	"./widgets/BeforeAfterWidget": 28,
	"./widgets/BeforeAfterWidget.js": 28,
	"./widgets/CardsWidget": 15,
	"./widgets/CardsWidget.js": 15,
	"./widgets/CoversWidget": 12,
	"./widgets/CoversWidget.js": 12,
	"./widgets/CtaWidget": 11,
	"./widgets/CtaWidget.js": 11,
	"./widgets/FeaturesWidget": 17,
	"./widgets/FeaturesWidget.js": 17,
	"./widgets/HtmlWidget": 35,
	"./widgets/HtmlWidget.js": 35,
	"./widgets/LargeSliderWidget": 30,
	"./widgets/LargeSliderWidget.js": 30,
	"./widgets/LeadImageWidget": 23,
	"./widgets/LeadImageWidget.js": 23,
	"./widgets/LlSectionWidget": 33,
	"./widgets/LlSectionWidget.js": 33,
	"./widgets/NavigationWidget": 24,
	"./widgets/NavigationWidget.js": 24,
	"./widgets/PaSectionWidget": 31,
	"./widgets/PaSectionWidget.js": 31,
	"./widgets/PageTitleWidget": 25,
	"./widgets/PageTitleWidget.js": 25,
	"./widgets/ProjectPreview": 18,
	"./widgets/ProjectPreview.js": 18,
	"./widgets/ProjectPreviewPlain": 36,
	"./widgets/ProjectPreviewPlain.js": 36,
	"./widgets/QuoteWidget": 27,
	"./widgets/QuoteWidget.js": 27,
	"./widgets/RaSectionWidget": 32,
	"./widgets/RaSectionWidget.js": 32,
	"./widgets/SectionTitleWidget": 19,
	"./widgets/SectionTitleWidget.js": 19,
	"./widgets/SingleImageSliderWidget": 29,
	"./widgets/SingleImageSliderWidget.js": 29,
	"./widgets/SingleImageWidget": 20,
	"./widgets/SingleImageWidget.js": 20,
	"./widgets/SpotlightWidget": 13,
	"./widgets/SpotlightWidget.js": 13,
	"./widgets/StatsWidget": 16,
	"./widgets/StatsWidget.js": 16,
	"./widgets/SwiperGallery": 53,
	"./widgets/SwiperGallery.js": 53,
	"./widgets/TextBoxWidget": 21,
	"./widgets/TextBoxWidget.js": 21,
	"./widgets/ThumbsWidget": 14,
	"./widgets/ThumbsWidget.js": 14,
	"./widgets/VideoWidget": 22,
	"./widgets/VideoWidget.js": 22,
	"./widgets/index": 5,
	"./widgets/index.js": 5
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60;